var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Woodfloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "00hGkYvVSWWoW7HNKrtDVa",
    x1: 14.359,
    x2: 35.942,
    y1: -2.486,
    y2: 56.813,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 24",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4943b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#cd822a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#c7701b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#c36511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2620e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#00hGkYvVSWWoW7HNKrtDVa)",
    d: "M39,7V41a2.033,2.033,0,0,1-.19.85A1.99943,1.99943,0,0,1,37,43H10.9A2.00708,2.00708,0,0,1,9,41V7a2.00587,2.00587,0,0,1,2-2H37A2.00587,2.00587,0,0,1,39,7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e39135",
    d: "M39,22.35V20.22c-2.86.83-5,4.01-5,7.78s2.14,6.95,5,7.78V33.65c-1.75-.82-3-3.04-3-5.65S37.25,23.17,39,22.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e39135",
    d: "M39,16.15V14.12c-5.64.9-10,6.78-10,13.88,0,7.02,4.27,12.85,9.81,13.85A2.033,2.033,0,0,0,39,41V39.85c-4.53-.91-8-5.87-8-11.85S34.47,17.06,39,16.15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e39135",
    d: "M37.5,8C29.5,8,23,16.97,23,28a23.75859,23.75859,0,0,0,4.92,15h2.69C27.23,39.78,25,34.26,25,28c0-9.93,5.61-18,12.5-18a8.283,8.283,0,0,1,1.5.13V8.1A12.32032,12.32032,0,0,0,37.5,8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e39135",
    d: "M29.87,5H26.04C20.65,9.1,17,16.98,17,26a28.92041,28.92041,0,0,0,5.16,17h2.51C21.21,38.96,19,32.84,19,26,19,16.15,23.58,7.8,29.87,5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e39135",
    d: "M16.15,36.78A43.846,43.846,0,0,1,17.7,43H15.67a43.46863,43.46863,0,0,0-1.43-5.64A41.55452,41.55452,0,0,1,12,24c0-7.93,3.75-15.04,6.35-19h2.42C18.36,8.42,14,15.77,14,24A39.28736,39.28736,0,0,0,16.15,36.78Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e39135",
    d: "M14.8,5A13.88586,13.88586,0,0,1,9,14.54V12.01A12.189,12.189,0,0,0,12.78,5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e39135",
    d: "M12.91,43H10.9A13.17578,13.17578,0,0,0,9,37.19V34.04C10.51,35.47,12.47,38.22,12.91,43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Woodfloor);
export default __webpack_public_path__ + "static/media/icons8-woodfloor.fa7f5038638a16d064aa7e9f27c85f96.svg";
export { ForwardRef as ReactComponent };